import { Button, ButtonLinkProps } from 'component-library';
import { FormProvider } from 'react-hook-form';

import { Plot } from '@/api/rest/resources/types/plot';
import { PlotBoundaryEditor } from '@/pages/landsteward/pages/plot/components/PlotBoundaryEditor';
import { useCreatePlotForm, usePlotForm } from '@/pages/landsteward/pages/plot/hooks/usePlotForm';

import { DraftPlotBoundaryEditorProps } from '../types';

const DraftPlotBoundaryEditorInner = ({ onForward, isForwardPending, onBack }: DraftPlotBoundaryEditorProps) => {
  const form = usePlotForm();

  const ForwardButton = ({ onClick, disabled, loading }: Omit<ButtonLinkProps, 'to'>) => (
    <Button
      type='button'
      disabled={!!disabled}
      loading={loading || isForwardPending}
      onClick={async (event) => {
        onClick?.(event);
        const multiPolygon = form.getValues('multiPolygon');
        if (!multiPolygon) return;
        await onForward(multiPolygon);
      }}
    >
      Save
    </Button>
  );

  const BackButton = ({ disabled }: Omit<ButtonLinkProps, 'to'>) => (
    <Button type='button' variant='outline' disabled={!!disabled} onClick={onBack}>
      Back
    </Button>
  );

  return <PlotBoundaryEditor existingPlots={[] as Plot[]} ForwardButton={ForwardButton} BackButton={BackButton} />;
};

export const DraftPlotBoundaryEditor = ({
  draftPlot,
  onForward,
  isForwardPending,
  onBack,
}: DraftPlotBoundaryEditorProps) => {
  const form = useCreatePlotForm({
    plot: {
      type: draftPlot.land_type,
      name: draftPlot.name,
      multi_polygon: draftPlot.multi_polygon ?? undefined,
      area: draftPlot.area,
    },
  });

  return (
    <FormProvider {...form}>
      <div className='fixed inset-0 z-50 bg-white-100'>
        <DraftPlotBoundaryEditorInner
          draftPlot={draftPlot}
          onForward={onForward}
          isForwardPending={isForwardPending}
          onBack={onBack}
        />
      </div>
    </FormProvider>
  );
};
